import homeSlide1 from "../../assests/home-slide-1.png"
import homeSlide2 from "../../assests/home-slide-2.png"
import homeSlide3 from "../../assests/home-slide-3.png"

export const homeSlider = [
    {
        id:1,
        source: homeSlide1,
        offerTitle:"KFC bucket",
        offerText:"3pcs @ Kes 150",
        height:"194px",
    },
    {
        id:2,
        source: homeSlide2,
        offerTitle:"KFC bucket",
        offerText:"3pcs @ Kes 150",
        height:"194px",
    },
    {
        id:3,
        source: homeSlide3,
        offerTitle:"KFC bucket",
        offerText:"3pcs @ Kes 150",
        height:"194px",
    },
]